// extracted by mini-css-extract-plugin
module.exports = {"container":"_9330de7794--container--zT41V","title":"_9330de7794--title--hDsIO"};